import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SetPinComponent } from './components/set-pin/set-pin.component';
import { BiometricLoginComponent } from './components/biometric-login/biometric-login.component';
import { TermsOfServiceComponent } from './components/terms-of-service/terms-of-service.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'set-pin', component: SetPinComponent },
      { path: 'terms', component: TermsOfServiceComponent },
      { path: 'biometric', component: BiometricLoginComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
